import NavOption from "../NavOption";
import React, { useState, useContext, useEffect } from "react";
import AuthContext from "../../../context/AuthContext";
import chevron from "../../../../assets/chevron.svg";
import styles from "./NavMenu.module.css";
import AuditMenu from "./AuditMenu";
import useGroupMemberships from "../../../../hooks/useGroupMemberships";

const AdminMenu = ({ ACTIONS, dispatch, state, closeMenus }) => {
  const authCtx = useContext(AuthContext);
  const [isAdmin, setIsAdmin] = useState(false);
  const groupMemberships = useGroupMemberships();

  useEffect(() => {
    setIsAdmin(groupMemberships.isPrimary || groupMemberships.isAuditPrimary);
  }, [groupMemberships, authCtx]);

  const onClickHandler = (event) => {
    event.preventDefault();
    dispatch({ type: ACTIONS.ADMIN_MENU_TOGGLE });
  };

  const closeMenu = () => {
    closeMenus();
  };

  const onBlurHandler = (event) => {
    event.preventDefault();
    if (
      !state.mobileMenuOpen &&
      !event.currentTarget.contains(event.relatedTarget)
    ) {
      closeMenu();
    }
  };

  const chevronClass = state.adminMenuOpen
    ? styles.chevronFocused
    : styles.chevron;

  const rootButtonClass = state.adminMenuOpen
    ? styles.titleButtonMenuFocused
    : styles.titleButtonMenu;

  return (
    <>
      {isAdmin && (
        <li onBlur={onBlurHandler}>
          <button className={rootButtonClass} onClick={onClickHandler}>
            Admin
            <img className={chevronClass} src={chevron} alt="" />
          </button>
          {state.adminMenuOpen && (
            <ul className={styles.subMenu1}>
              {groupMemberships.isPrimary && (
                <NavOption
                  displayText={"AD Groups"}
                  navigateTo={"/collectorADGroups"}
                  closeParentMenu={closeMenu}
                  ACTIONS={ACTIONS}
                  dispatch={dispatch}
                  state={state}
                  closeMenus={closeMenus}
                />
              )}
              <NavOption
                displayText={"Crews"}
                navigateTo={"/crews"}
                closeParentMenu={closeMenu}
                ACTIONS={ACTIONS}
                dispatch={dispatch}
                state={state}
                closeMenus={closeMenus}
              />
              <AuditMenu
                ACTIONS={ACTIONS}
                dispatch={dispatch}
                state={state}
                closeMenus={closeMenus}
              />
            </ul>
          )}
        </li>
      )}
    </>
  );
};

export default AdminMenu;
